<template>
  <div class="consent-banner" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="banner-content">
      <!-- prettier-ignore -->
      <div class="text-box">
        {{ $t('cookie_consent.cookies_infotext_before').trim() }}&nbsp;<span class="config-link"
                                                                      @click="openConfig">{{ $t('cookie_consent.cookies_configure_here')
        }}</span>{{ $t('cookie_consent.cookies_infotext_after') }}
      </div>
      <div class="button-box">
        <button class="button is-primary" @click="sendChoice({ statistics: true, other: true })">
          {{ $t('cookie_consent.cookies_accept') }}
        </button>
        <button class="button is-secondary" @click="sendChoice({ statistics: false, other: false })">
          {{ $t('cookie_consent.cookies_refuse') }}
        </button>
        <button class="button is-secondary" @click="openConfig()">
          {{ $t('cookie_consent.cookies_configure_link') }}
        </button>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  emits: ['save-choice', 'open-config'],

  methods: {
    openConfig() {
      this.$emit('open-config');
    },
    sendChoice(values) {
      this.$emit('save-choice', { statistics: values.statistics, other: values.other });
    }
  }
};
</script>

<style scoped>
.consent-banner {
  position: fixed;
  width: 100%;
  bottom: 0px;
  background-color: #f2f2f2;
  box-shadow: 0 0 2em rgba(0, 0, 0, 0.4), 0 1px 4px rgba(0, 0, 0, 0.3);
  outline: none;
}

.banner-content {
  max-width: 480px;
  margin: 0 auto;
  padding: 0.875rem 0.875rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

@media screen and (min-width: 768px) {
  .banner-content {
    max-width: 1200px;
    padding: 1.5rem 1.25rem;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
}

.text-box {
  flex: 1 1 auto;
  text-align: justify;
  font-size: 0.875rem;
}

@media screen and (min-width: 768px) {
  .text-box {
    margin-right: 2rem;
    max-width: 720px;
    font-size: 1rem;
  }
}

.config-link {
  display: inline-block;
  cursor: pointer;
  text-decoration: underline;
}

.button-box {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  gap: 1rem;
}

@media (max-width: 479px) {
  .button-box {
    flex-wrap: wrap;
  }
}

@media (min-width: 768px) {
  .button-box {
    flex-direction: column;
    align-items: stretch;
  }
}

.button-as-link {
  min-width: 12rem;
  margin-top: 0.5rem;
  margin-right: 0.5rem;
  padding: 0.375rem 1rem;
  font-size: 0.875rem;
  color: #424242;
  background: none;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  cursor: pointer;
}

@media (max-width: 479px) {
  .button-as-link {
    margin-right: 0;
  }
}

@media (min-width: 768px) {
  .button-as-link {
    margin-right: 0;
    border: 0;
    text-decoration: underline;
  }
}

.button-std,
.button-cta,
.button-as-link {
  margin-top: 0.5rem;
  width: 100%;
}

@media (min-width: 768px) {
  .button-cta {
    margin-top: 0;
  }
}
</style>
